import React from 'react'
import langTranslate from 'locale'
import { ReactComponent as FlightsIcon } from 'assets/icons/flights_active.svg'
import { ReactComponent as HotelsIcon } from 'assets/icons/hotelsNew.svg'
import { ReactComponent as Trains } from 'assets/icons/train.svg'
import { ReactComponent as Trips } from 'assets/icons/tripsNew.svg'
import { ReactComponent as RightArr } from 'assets/icons/rightarr.svg'
import { ReactComponent as Percentage } from 'assets/icons/offersNew.svg'
import { ReactComponent as Support } from 'assets/icons/supportNew.svg'
import { ReactComponent as Staycation } from 'assets/icons/staycation.svg'
import { ReactComponent as Visa } from 'assets/icons/visa.svg'
import { ReactComponent as Cfw } from 'assets/icons/workNew.svg'
import { ReactComponent as Gift } from 'assets/icons/gift-card.svg'
import { dataLayerGA } from 'utils/dataLayerHelper.js'
import classNames from 'classnames'
import { isFeatureEnabled } from 'utils/uiHelper'
import './style.scss'
import { isUserSignedIn } from 'utils/browserHelper'

const Humberger = () => {
    const humbgerObject = {
        home: true,
        hotels: true,
        train: false,
        work: false,
        offer: false,
        gift: false,
        activities: false,
        staycation: false,
        visa: false,
        support: true,
        trip: true,
        sale: false
    }
    // const tabClass = classNames(
    //     defaultClass,
    //     {
    //         'bg-secondary-100': active,
    //         'hover:bg-neutral-0': !isDisabled && !active
    //     },
    //     className
    // )
    function getPopularCities(domain) {
        switch (domain) {
            case 'www.cleartrip.com':
            case 'qa2new.cleartrip.com':
            case 'airdev.cleartrip.com':
            case 'localhost':
                humbgerObject.train = false
                humbgerObject.work = true
                humbgerObject.offer = true
                humbgerObject.gift = true
                humbgerObject.sale = false
                break
            case 'www.cleartrip.ae':
            case 'qa2.cleartrip.ae':
                humbgerObject.staycation = true
                humbgerObject.visa = true
                break
        }
        return humbgerObject
    }
    const humbgerShow = getPopularCities(window.location.hostname)
    const isRTL = process.env.CONTENT_DIR === 'RTL'
    const { humbgerSale = {} } = isFeatureEnabled()
    const handleSupportClick =()=>{
        dataLayerGA({ clicked_option_name: event, section: 'Navigation' }, 'hamburger_menu_click')
        let url = '/support'
        const signedIn = isUserSignedIn()
         if (signedIn) {
             url = '/accounts/trips'
         }
         window.open(url, '_blank')
    }
    const handleClick = event => {
        dataLayerGA({ clicked_option_name: event, section: 'Navigation' }, 'hamburger_menu_click')
        
    }
    return (
        <>
            <div className="mt-2 mb-2 d-block fs-6">
                <ul className="ls-reset">
                    <li className="bg-secondary-100 br-6">
                        <a
                            className="c-secondary-500 fs-4 pl-2 fw-300 td-none flex flex-middle"
                            href="/flights"
                            style={{ height: 40 }}
                            onClick={() => handleClick('Flights')}
                        >
                            <FlightsIcon fill="#3366CC" height="20px" width="20px" />
                            <div className="ml-4 mr-2 c-secondary-500 fs-4 fw-500 flex flex-1">
                                {langTranslate('Flights')}
                            </div>
                        </a>
                    </li>
                    <li className="mt-4 listItemHover">
                        <a
                            className=" fs-4 pl-2 fw-300  td-none flex flex-middle"
                            href="/hotels"
                            style={{ height: 40 }}
                            onClick={() => handleClick('Hotels')}
                        >
                            <HotelsIcon className="stroke" height="20px" width="20px" />
                            <div className="ml-4 mr-2  fs-4 fw-500  flex flex-1">{langTranslate('Hotels')}</div>
                            {/* <RightArr
                                fill="#d4d4d4"
                                className={classNames('', isRTL ? 'ml-2 mr-2 arrow_rtl' : 'ml-2 mr-2')}
                            /> */}
                        </a>
                    </li>
                    {humbgerShow.offer && (
                        <li className="mt-4 listItemHover">
                            <a
                                className=" fs-4 pl-2 fw-300  td-none flex flex-middle"
                                href="/offers/india"
                                target="_blank"
                                style={{ height: 40 }}
                                onClick={() => handleClick('Offers')}
                            >
                                <Percentage className="stroke" height="22px" width="22px" />
                                <div className="ml-4 mr-20 fs-4 fw-500 flex flex-1">{langTranslate('Offers')}</div>
                            </a>
                        </li>
                    )}
                    {/* {humbgerShow.staycation && (
                        <li className="mt-2">
                            <a
                                className=" fs-4 pl-2 fw-300  td-none flex flex-middle"
                                href="/activities/dubai/collection/uae-staycations"
                                style={{ height: 45 }}
                            >
                                <Staycation fill="#999" height="20px" width="20px" />
                                <div className="ml-2 mr-20 fs-4 flex flex-1">
                                    {langTranslate('Staycations')}
                                </div>
                                <RightArr
                                    fill="#d4d4d4"
                                    className={classNames('', isRTL ? 'ml-2 mr-2 arrow_rtl' : 'ml-2 mr-2')}
                                />
                            </a>
                        </li>
                    )} */}
                    <li className="mt-4 listItemHover">
                        <a
                            className=" fs-4 pl-2 fw-300  td-none flex flex-middle"
                            href="/account/trips"
                            style={{ height: 40 }}
                            onClick={() => handleClick('My Trips')}
                        >
                            <Trips className="fill" height="22px" width="22px" />
                            <div className="ml-4 mr-20 fs-4 flex flex-1 fw-500">{langTranslate('My trips')}</div>
                        </a>
                    </li>
                    {/* {humbgerShow.visa && (
                        <li className="mt-2">
                            <a
                                className=" fs-4 pl-2 fw-300  td-none flex flex-middle"
                                href="/visa/dubai"
                                style={{ height: 45 }}
                            >
                                <Visa fill="#999" height="20px" width="20px" />
                                <div className="ml-2 mr-20 fs-4 flex flex-1">{langTranslate('UAE Visa')}</div>
                                <RightArr
                                    fill="#d4d4d4"
                                    className={classNames('', isRTL ? 'ml-2 mr-2 arrow_rtl' : 'ml-2 mr-2')}
                                />
                            </a>
                        </li>
                    )} */}
                    {/* {humbgerShow.train && (
                        <li className="mt-2">
                            <a
                                className=" fs-4 pl-2 fw-300  td-none flex flex-middle"
                                href="/trains"
                                style={{ height: 45 }}
                            >
                                <Trains fill="#999" height="20px" width="20px" />
                                <div className="ml-2 mr-20 fs-4 flex flex-1">{langTranslate('Trains')}</div>
                                <RightArr
                                    fill="#d4d4d4"
                                    className={classNames('', isRTL ? 'ml-2 mr-2 arrow_rtl' : 'ml-2 mr-2')}
                                />
                            </a>
                        </li>
                    )} */}
                    {humbgerShow.work && (
                        <li className="mt-4 listItemHover">
                            <a
                                className=" fs-4 pl-2 fw-300  td-none flex flex-middle"
                                href="https://business.cleartrip.com/"
                                target="_blank"
                                style={{ height: 40, whiteSpace:'nowrap'}}
                                onClick={() => handleClick('Cleartrip for Work')}
                            >
                                <Cfw className="fill" height="20px" width="20px" />
                                <div className="ml-2 mr-20 fs-4 flex flex-1 fw-500 ml-2 mr-20 fs-4 flex flex-1">
                                    {langTranslate('Cleartrip for Business')}
                                </div>
                            </a>
                        </li>
                    )}

                    {/* {humbgerShow.gift && (
                        <li className="mt-2">
                            <a
                                className=" fs-4 pl-2 fw-300  td-none flex flex-middle"
                                href="/giftcards"
                                target="_blank"
                                style={{ height: 45 }}
                            >
                                <Gift fill="#999" height="20px" width="20px" />
                                <div className="ml-2 mr-20 fs-4 flex flex-1">{langTranslate('Gift Card')}</div>
                            </a>
                        </li>
                    )} */}
                    {humbgerShow.support && (
                        <li className="mt-4 listItemHover">
                            <a
                                className=" fs-4 pl-2 fw-300  td-none flex flex-middle"
                                href="/support"
                                target="_blank"
                                style={{ height: 40 }}
                                onClick={() => handleSupportClick('Support')}
                            >
                                <Support className="fill" height="20px" width="20px" />
                                <div className="ml-4 mr-20 fs-4 flex flex-1 fw-500">{langTranslate('Support')}</div>
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        </>
    )
}

export default Humberger
